import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

function Layout() {
  const { pathname } = useLocation();
  const noScroll =
    pathname.startsWith("/intekenen") || pathname.startsWith("/viewer");

  return (
    <div className="appLayout">
      <Navbar />

      <main className={`appMain ${noScroll ? "noScroll" : "scroll"}`}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}

export default Layout;
